import axios from 'axios';
import csrfToken from '../shared/meta';

const recordMediaStatisticStatuses = [];

export function recordStatisticsEvent(statisticsData) {
  const headers = {
    'X-CSRF-Token': csrfToken(),
    'Content-Type': 'application/json',
  };

  return axios.post('/statistic_events/create.json', JSON.stringify({ statistics_data: statisticsData }), { headers });
}

export function recordProfileStatistic(profileId, eventName) {
  recordStatisticsEvent({
    event: eventName,
    statisticable: 'profile',
    id: profileId,
    page: window.location.pathname,
  });
}

export function recordFundStatistic(fundId, eventName) {
  recordStatisticsEvent({
    event: eventName,
    statisticable: 'fund',
    id: fundId,
    page: window.location.pathname,
  });
}

export function recordSimilarContributorsStatistic(profileId) {
  recordStatisticsEvent({
    event: 'full_wire_sidebar_similar_contributors_clicked',
    statisticable: 'profile',
    id: profileId,
  });
}

function recordWireStatistic(wireId, event) {
  recordStatisticsEvent({
    id: wireId,
    event,
    statisticable: 'wire',
  });
}

// NOTE this only actually records the stat once per media
function recordMediaPlayStartStatistic(wireId, provider) {
  if (recordMediaStatisticStatuses[wireId]) return;

  recordMediaStatisticStatuses[wireId] = 'playing';

  recordWireStatistic(wireId, `${provider}_play`);
}

// NOTE this only actually records the stat once per media
function recordMediaPlayFinishedStatistic(wireId, provider) {
  if (recordMediaStatisticStatuses[wireId] !== 'playing') return;

  recordMediaStatisticStatuses[wireId] = 'finished';

  recordWireStatistic(wireId, `${provider}_finished`);
}

export function recordYoutubePlayStartStatistic(wireId) {
  recordMediaPlayStartStatistic(wireId, 'youtube');
}
export function recordYoutubePlayFinishedStatistic(wireId) {
  recordMediaPlayFinishedStatistic(wireId, 'youtube');
}
export function recordVimeoPlayStartStatistic(wireId) {
  recordMediaPlayStartStatistic(wireId, 'vimeo');
}
export function recordVimeoPlayFinishedStatistic(wireId) {
  recordMediaPlayFinishedStatistic(wireId, 'vimeo');
}
export function recordSoundcloudPlayStartStatistic(wireId) {
  recordMediaPlayStartStatistic(wireId, 'soundcloud');
}
export function recordSoundcloudPlayFinishedStatistic(wireId) {
  recordMediaPlayFinishedStatistic(wireId, 'soundcloud');
}
export function recordWistiaPlayStartStatistic(wireId) {
  recordMediaPlayStartStatistic(wireId, 'wistia');
}
export function recordWistiaPlayFinishedStatistic(wireId) {
  recordMediaPlayFinishedStatistic(wireId, 'wistia');
}
export function recordPodbeanPlayStartStatistic(wireId) {
  recordMediaPlayStartStatistic(wireId, 'podbean');
}
export function recordPodbeanPlayFinishedStatistic(wireId) {
  recordMediaPlayFinishedStatistic(wireId, 'podbean');
}
